import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import { user } from "@/store/module/user";
import { router } from "@/store/module/router";
import { dictionary } from "@/store/module/dictionary";
import { app } from "@/store/module/app";
import { game } from "@/store/module/game";
import { gameServer } from "@/store/module/gameServer";
import { userInfo } from "@/store/module/userInfo";
import { itemPay } from "@/store/module/itemPay";
import { reasonMsg } from "@/store/module/reasonMsg";
import { gameGoods } from "@/store/module/gameGoods";
import { coupon } from "@/store/module/coupon";
import { gameTask } from "@/store/module/gameTask";
import { gameScene } from "@/store/module/gameScene";
import { gameXingxing } from "@/store/module/gameXingxing";
import { authority } from "@/store/module/authority";
import { seloptions } from "@/store/module/seloptions";
import { gamePartner } from "@/store/module/gamePartner";
import { gameCoin } from "@/store/module/gameCoin";
import { gameChannel } from "@/store/module/gameChannel";
import { gameEvent } from "@/store/module/gameEvent";
import { adPosition } from "@/store/module/adPosition";
import { gameplayType } from "@/store/module/gameplayType";
Vue.use(Vuex);
var vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['user']
});
export var store = new Vuex.Store({
  modules: {
    user: user,
    router: router,
    dictionary: dictionary,
    app: app,
    game: game,
    seloptions: seloptions,
    gameServer: gameServer,
    gameGoods: gameGoods,
    coupon: coupon,
    gameTask: gameTask,
    gameScene: gameScene,
    gameXingxing: gameXingxing,
    authority: authority,
    reasonMsg: reasonMsg,
    itemPay: itemPay,
    userInfo: userInfo,
    gamePartner: gamePartner,
    gameCoin: gameCoin,
    gameChannel: gameChannel,
    gameEvent: gameEvent,
    adPosition: adPosition,
    gameplayType: gameplayType
  },
  plugins: [vuexLocal.plugin]
});